import React, { useState, useEffect } from 'react'
import { Box, Typography, TextField, Select, MenuItem, Switch, Button, InputLabel, Snackbar, Alert, TextareaAutosize } from '@mui/material'
import { useForm, Controller } from 'react-hook-form'
import elrondApi from '../../api/elrond'
import axios from 'axios'
import globalStyles from '../../utils/globalStyles'

function AddressForm(props) {
  // console.log(props)
    const { address, isB2B, } = props;

  const [countryList, setCountryList] = React.useState([])
  const [districtList, setDistrictList] = React.useState([])
  const [cityList, setCityList] = React.useState([])
  const [countryCode, setCountryCode] = React.useState('')
  const [cityCode, setCityCode] = React.useState('')
  const [districtCode, setDistrictCode] = React.useState('')
  const [openAlert, setOpenAlert] = React.useState(false)
  const [alertText, setAlertText] = React.useState('')
  const [value, setValue] = React.useState([])
  const [countryPhoneExt, setCountryPhoneExt] = useState('+966');
  const [phonePH, setPhonePH] = useState("Enter phone number");
  const [otherCity, setOtherCity] = useState('');
  const [otherDistrict, setOtherDistrict] = useState('');
  const [remarksString, setRemarksString] = React.useState('')
  const [focus, setFocus] = React.useState(false);
  const [countryExtCodes, setCountryExtCodes] = useState([
    { code: 'SA', text: '+966', length: 9, start: ['5'], emoji: "🇸🇦", flag: '/static/content/flag-saudi.png', regEx: '^(5)[0-9]{8}$', repExp: '^(00966|966|\\+966)', pHolder: '5X XXX XXXX' },
    { code: 'AE', text: '+971', length: 9, start: ['5'], emoji: "🇦🇪", flag: '/static/content/flag-uae.png', regEx: '^(5)[0-9]{8}$', repExp: '^(00971|971|\\+971)', pHolder: '5X XXX XXXX' },
    { code: 'BH', text: '+973', length: 8, start: ['3'], emoji: "🇧🇭", flag: '/static/content/flag-baharain.png', regEx: '^(3)[0-9]{7}$', repExp: '^(00973|973|\\+973)', pHolder: '3X XXX XXX' },
    { code: 'OM', text: '+968', length: 8, start: ['7', '9'], emoji: "🇴🇲", flag: '/static/content/flag-oman.png', regEx: '^(7|9)[0-9]{7}$', repExp: '^(00968|968|\\+968)', pHolder: '7X XXX XXX' },
    { code: 'KW', text: '+965', length: 8, start: ['9','5','6'], emoji: "🇰🇼", flag: '/static/content/flag-kuwait.png', regEx: '^(5|6|9)[0-9]{7}$', repExp: '^(00965|965|\\+965)', pHolder: '9X XXX XXX' },
    { code: 'QA', text: '+974', length: 8, start: ['3', '5', '9'], emoji: "", flag: '/static/content/flag-qatar.png', regEx: '^(3|5|9)[0-9]{7}$', repExp: '^(00974|974|\\+974)', pHolder: '3X XXX XXX' },
  ]);

  const { handleSubmit, control, reset, getValues } = useForm({
    defaultValues: {
      fullname: props.address
      ? `${props.address.firstname || ''} ${props.address.lastname || ''}`.trim()
      : '',
      middlename: props.address == null ? null : props.address.middlename,
      company: props.address == null ? null : props.address.company,
      street: props.address == null ? null : props.address.street,
      postcode: props.address == null ? null : props.address.postcode,
      telephone: props.address == null ? null : props.address.telephone,
      phone_ext: props.address == null ? null : props.address.phone_ext,
      city_id: props.address?.city_id || "",
      other_city:props.address?.city_id === "0" || props.address?.city_id == null ? props.address?.city || "" : "",
      district_id: props.address?.district_id === null ? "0" : props.address?.district_id, // Treat null as "0"
      other_district: (props.address?.district_id === "0" || props.address?.district_id == null) ? props.address?.district || "" : "",
      remarksString: '',
      building_no: isB2B ? address?.building_no || '' : '', // <-- only for B2B
      premisesCode: props.address?.premisesCode || "",   // <-- Add this
      customer_unique_id: props.address?.customer_unique_id || "", 

    }
  })
  const handleOutsideFocus = () => {
    setFocus(false);
  }

  function validateShortAddressCode(code) {
    const shortAddressRegex = /^[A-Z]{4}\d{4}$/;
    return shortAddressRegex.test(code?.toUpperCase().trim());
  }

  const validatePhoneNumber = (value) => {
    // Find the selected country's configuration
    const selectedCountry = countryExtCodes.find(
      (country) => country.text === countryPhoneExt
    );
  
    if (!selectedCountry) {
      return "Invalid country selection.";
    }
  
    if (!value || value.length === 0) {
      return "Phone number is required.";
    }
  
    // Check if the phone number matches the selected country's pattern
    const phoneRegex = new RegExp(selectedCountry.regEx);
    if (!phoneRegex.test(value)) {
      return `Invalid phone number format. Expected: ${selectedCountry.pHolder}`;
    }
  
    return true; // Validation passed
  };
  
  const handlePhoneInput = (e, onChange) => {
    const inputValue = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
  
    const selectedCountry = countryExtCodes.find(
      (country) => country.text === countryPhoneExt
    );
  
    if (selectedCountry) {
      // Limit the input to the maximum length for the selected country
      const trimmedValue = inputValue.slice(0, selectedCountry.length);
      onChange(trimmedValue); // Update the value
    } else {
      onChange(inputValue); // Default behavior for no selected country
    }
  };

  const submitForm = () => {
    const values = getValues();
    const rawPostcode = (values.postcode || '').toString().trim();
    // --- names from fullname ---
    const fullname = (values.fullname || '').trim();
    if (!fullname) {
      return handleAlertGen(isB2B ? 'Full Name is required!' : 'First Name is required!');
    }
    const [first, ...lastArr] = fullname.split(/\s+/);
    const first_name = first || '';
    const last_name = lastArr.join(' ');
   if (isB2B && !values.building_no) {
      return handleAlertGen('Building No. is required for B2B orders!');
    }
    
    // --- normalize helpers ---
    const S = v => (typeof v === 'string' ? v.trim() : String(v ?? ''));
    const asStr = v => String(v ?? '');
    const nonEmpty = v => S(v) !== '';

    // --- current/original address (map both snake/camel just in case) ---
    const original = props.address || {};
    const cleanOriginal = {
      first_name: original.first_name ?? original.firstname ?? '',
      last_name: original.last_name ?? original.lastname ?? '',
      postcode: original.postcode ?? '',
      telephone: original.telephone ?? '',
      phone_ext: original.phone_ext ?? '',
      street: original.street ?? '',
      city: original.city ?? '',
      city_id: asStr(original.city_id ?? ''),
      city_code: original.city_code ?? '',
      district: original.district ?? '',
      district_id: asStr(original.district_id ?? ''),
      district_code: original.district_code ?? '',
      country: original.country ?? '',
      country_code: original.country_code ?? '',
      country_id: original.country_id ?? '',
      remarks: original.remarks ?? '',
      building_no: isB2B ? values.building_no : '', // only submit for B2B
      premisesCode: original.premisesCode ?? '', // <-- ADD THIS
      customer_unique_id: original.customer_unique_id ?? '',

    };

    // --- read selects / ids as strings (so '0' works) ---
    const cityIdStr = asStr(values.city_id ?? cleanOriginal.city_id ?? '');
    const districtIdStr = asStr(values.district_id ?? cleanOriginal.district_id ?? '');

    // --- validation (no checking values.firstname/lastname anymore) ---
    let message = '';
    if (!nonEmpty(values.street)) message = 'Street is required!';
    else if (props.isB2B && !nonEmpty(values.building_no)) message = 'Building No. is required!';
    else if (!nonEmpty(countryCode)) message = 'Country is required!';
    else if (!nonEmpty(cityCode)) message = 'City is required!';
    else if (cityIdStr === '0' && !nonEmpty(values.other_city)) message = 'Enter City Name!';
    else if (!nonEmpty(districtCode)) message = 'District is required!';
    else if (districtIdStr === '0' && !nonEmpty(values.other_district)) message = 'Enter District Name!';  
    else if (countryCode === 'SA' && !validateShortAddressCode(values.premisesCode)) { message = 'National Address Short Code must be 4 letters followed by 4 digits (e.g. RCTB4359)'; }
    else if ( countryCode === 'QA' && ( !values.customer_unique_id || !/^\d{11}$/.test(values.customer_unique_id))) { message = 'Qatari ID must be exactly 11 digits!';}
    else if (!nonEmpty(countryPhoneExt)) message = 'Country phone ext. is required!'; // validate what you actually send
    else if (!rawPostcode) { message = 'Postcode is required!'; }
    else if (countryCode === 'SA' && !/^\d{5}$/.test(rawPostcode)) { message = 'For Saudi Arabia, postcode must be exactly 5 digits!'; }
    else if (countryCode !== 'SA' && (!/^\d+$/.test(rawPostcode) || rawPostcode.length > 9)) { message = 'Postcode must be numeric and up to 9 digits!'; }
    else if (!nonEmpty(countryPhoneExt)) message = 'Country phone ext. is required!'; // validate what you actually send
    else if (!nonEmpty(values.telephone)) message = 'Phone number is required!';
    else {
      const r = values.remarksString ? values.remarksString.trim() : "";
      if (r.length < 5 || r.length > 255) {
        message = 'Please enter Remarks data between 5 to 255 characters length!';
      } else {
        const phoneCheck = validatePhoneNumber(values.telephone);
        if (phoneCheck !== true) message = phoneCheck;
      }
    }
    if (message) return handleAlertGen(message);


    const foundCountry = countryList.find(c => c.code == countryCode) || {};
    const countryValue = foundCountry.value || '';
    const countryId = foundCountry.id || '';

    const cityObj = cityIdStr === '0' ? null : (cityList.find(c => asStr(c.id) === cityIdStr) || null);
    const districtObj = districtIdStr === '0' ? null : (districtList.find(d => asStr(d.id) === districtIdStr) || null);

    const city_code = cityIdStr === '0' ? 'other' : (cityObj?.code ?? cleanOriginal.city_code ?? '');
    const city = cityIdStr === '0' ? S(values.other_city) : (cityObj?.value ?? cleanOriginal.city ?? '');

    const district_code = districtIdStr === '0' ? 'other' : (districtObj?.code ?? cleanOriginal.district_code ?? '');
    const district = districtIdStr === '0' ? S(values.other_district) : (districtObj?.value ?? cleanOriginal.district ?? '');

    const payload = {
      first_name: first_name,
      last_name: last_name,
      city_id: cityIdStr || cleanOriginal.city_id || '',
      city_code,
      city,
      district_id: districtIdStr || cleanOriginal.district_id || '',
      district_code,
      district,
      country_id: countryCode,
      country_code: countryId,
      country: countryValue,
      street: S(values.street),
      phone_ext: countryPhoneExt,
      postcode: S(values.postcode),
      telephone: S(values.telephone),
      is_default_billing: false,
      is_default_shipping: false,
      remarks: S(values.remarksString),
      building_no: props.isB2B ? S(values.building_no) : '', // Include only for B2B
      premisesCode: S(values.premisesCode || ''),  // <-- Add this
     customer_unique_id:  S(values.customer_unique_id || ''),
    };

    const modified_value = {};
    for (const key of Object.keys(cleanOriginal)) {
      if (['first_name', 'last_name', 'telephone', 'phone_ext'].includes(key)) continue;
      const oldVal = S(cleanOriginal[key]);
      const newVal = S(payload[key]);
      if (oldVal !== newVal) modified_value[key] = newVal; // <-- NEW values
    }
    const fullNameOld = `${S(cleanOriginal.first_name)} ${S(cleanOriginal.last_name)}`.trim();
    const fullNameNew = `${S(first_name)} ${S(last_name)}`.trim();
    if (fullNameOld !== fullNameNew) modified_value.full_name = fullNameNew;

    const mobileOld = `${S(cleanOriginal.phone_ext)}${S(cleanOriginal.telephone)}`;
    const mobileNew = `${S(payload.phone_ext)}${S(payload.telephone)}`;
    if (mobileOld !== mobileNew) modified_value.mobile = mobileNew;

    if (Object.keys(modified_value).length > 0) {
      payload.modified_value = modified_value;
    }

    // --- submit ---
    if (!props.address) {
      props.AddorEditAddress?.(payload, 'add');
    } else {
      payload.address_id = props.address.entity_id;
      props.AddorEditAddress?.(payload, 'edit');
    }
  };

  const cancelForm = () => {
    props.closeFormModal()
  }
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '500px',
    height: 'auto',
    maxHeight: '85vh',
    overflow: 'scroll',
    backgroundColor: '#fff',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };

  React.useEffect(() => {
    console.log('loading address: ')
    console.log(props.address)
    let defaultCountry = props.address && props.address.country_id ? props.address.country_id : 'SA';
    setCountryCode(props.address && props.address.country_id ? props.address.country_id : 'SA');
    setCityCode(props.address && props.address.city_id ? props.address.city_id : '');
    setDistrictCode(props.address && props.address.district_id ? props.address.district_id : '');
    setValue(props.address && props.address.phone_ext ? props.address.phone_ext : '');


    axios.get(`${elrondApi.url}/hnak/locationdata/${elrondApi.source}`).then(res => {
      // console.log("on load api address data", res.data.data);
      const defaultCountryList = res.data.data;
      const foundCountry = defaultCountryList.find(country => country.code == defaultCountry)
      setCountryList(defaultCountryList);
      let defaultCityList = foundCountry.cities
      let defaultDistrictList = foundCountry.districts
      setCityList(defaultCityList);
      setDistrictList(defaultDistrictList);
      const countryExt = countryExtCodes.find(ext => ext.code === foundCountry.code);
      if (countryExt) {
        setCountryPhoneExt(countryExt.text);
        setPhonePH(countryExt.pHolder);
      }
      if (props.address) {
        setValue('phone_ext', countryExt.text);
        setValue('telephone', props.address.telephone || ''); // Initialize telephone if provided
        setValue('premisesCode', props.address.premisesCode || "");   
        setValue('customer_unique_id', props.address.customer_unique_id || "");   
      }
    });
  }, [props.address])

  const handleCountry = (e) => {
    // console.log("Country", e);
    setCountryCode(e);
    const foundCountry = countryList.find(country => country.code == e)
    console.log("Country found", foundCountry);
    let changingCityList = foundCountry.cities
    let changingDistrictList = foundCountry.districts
    setCityList(changingCityList);
    setDistrictList(changingDistrictList);
    const countryExt = countryExtCodes.find(ext => ext.code === foundCountry.code);
    if (countryExt) {
      setCountryPhoneExt(countryExt.text);
      setPhonePH(countryExt.pHolder);
      reset({
        ...getValues(), // Preserve other form fields
        phone_ext: countryExt ? countryExt.text : "",
        telephone: "",
        city_id: "", // Clear the city selection
        street: "",
        district_id: "", // Clear the district selection
        other_city: "", // Reset custom city input
        other_district: "", // Reset custom district input
        building_no: "",
        premisesCode: "",
        customer_unique_id: "",
      });
      setCityCode(""); // Clear city code state
      setDistrictCode(""); 
    }
  }

  const handleAlertGen = (message) => {
    setAlertText(message)
    setOpenAlert(true)
    setTimeout(() => {
      setAlertText('')
      setOpenAlert(false)
    }, 3000)
  }
  const closeAlert = () => {
    setOpenAlert(false)
  }

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setCityCode(selectedCity);
    if (selectedCity !== 'Others') {
      setOtherCity('');
    }
          setValue("other_city", ""); 

    reset({
      ...getValues(),
      street: "",
      city_id: selectedCity,
    });
  };

  const handleDistrictChange = (e) => {
    const selectedDistrict = e.target.value;
    setDistrictCode(selectedDistrict);
    if (selectedDistrict !== 'Others') {
      setOtherDistrict('');
    }
    reset({
      ...getValues(),
      street: "",
      district_id: selectedDistrict,
    });
  };

  return (
    <Box sx={style}>
      <Typography variant='h5'>Add/Update Address</Typography>
      <Box>
        <form>
          {/* <Controller 
            name='firstname' 
            control={control} 
            rules={{ required: true}}
            render={({field}) => <TextField {...field} label='First Name*' fullWidth/>}
          />
          <Controller 
            name='lastname'
            control={control} 
            rules={{ required: true}}
            render={({field}) => <TextField {...field} label='Last Name*' fullWidth/>}
          /> */}
          <Controller
            name="fullname"
            control={control}
            rules={isB2B
              ? {
                  required: 'Full Name is required',
                  validate: value => value.trim().split(' ').length >= 2 || 'Please enter both first and last names'
                }
              : {
                  required: 'First Name is required',
                  validate: value => value.trim().length >= 1 || 'First Name must contain at least 1 character'
                }
            }
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                label={isB2B ? 'Full Name*' : 'First Name* (Last Name optional)'}
                fullWidth
                error={!!error}
                helperText={error?.message}
              />
            )}
          />
          <Box sx={{
            display: 'inline-flex',
            width: '100%',
            alignItems: 'center',
            margin: '10px'
          }}>
            <Box sx={{ width: '20%' }}>{'Country:'}</Box>
            <Box sx={{ width: '50%' }}>
              <Controller
                name='country_id'
                control={control}
                //rules={{ required: true}}
                render={({ field }) =>
                  <>
                    <Select
                      {...field}
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      defaultValue={props.address && props.address.country_id ? props.address.country_id : ''}
                      label="Country"
                      onChange={(e) => handleCountry(e.target.value)}
                      sx={{ width: '100%', overflow: 'visible' }}
                    >
                      {
                        countryList.map(country => {
                          return (
                            <MenuItem value={country.code}>{country.value}</MenuItem>
                          )
                        })
                      }
                    </Select></>}
              />
             {(countryCode === 'QA' || countryCode === 'OM') && (
  <Controller
    name="customer_unique_id"
    control={control}
    rules={{
      required:
        countryCode === "QA"
          ? "Please enter Qatari ID"
          : "Please enter Oman ID",
      pattern: {
        value: countryCode === "QA" ? /^\d{11}$/ : /^\d{8}$/,
        message:
          countryCode === "QA"
            ? "Please enter Qatari ID"
            : "Please enter Oman ID",
      },
    }}
    render={({ field, fieldState: { error } }) => (
      <TextField
        {...field}
        label={
          countryCode === "QA"
            ? "Qatari ID (11-Digit)*"
            : "Oman ID (8-Digit)*"
        }
        fullWidth
        error={!!error}
        helperText={error?.message}
        inputProps={{
          maxLength: countryCode === "QA" ? 11 : 8,
          inputMode: "numeric",
        }}
        onChange={(e) => {
          const maxLength = countryCode === "QA" ? 11 : 8;
          const value = e.target.value.replace(/\D/g, "").slice(0, maxLength);
          field.onChange(value);
        }}
      />
    )}
  />
)}
            </Box>
            
          </Box>
         
          <Box sx={{
            display: 'inline-flex',
            width: '100%',
            alignItems: 'center',
            margin: '10px'
          }}>
            <Box sx={{ width: '20%' }}>{'City:'}</Box>
            <Box sx={{ width: '50%' }}>
              <Controller
                name="city_id"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <>
                    <Select
                      {...field}
                      label="City"
                      value={field.value || ""} 
                      onChange={(e) => {
                        field.onChange(e.target.value); 
                        handleCityChange(e); 
                      }}
                      sx={{ width: '100%', overflow: 'visible', mb: 2 }}
                    >
                      {cityList.map((city) => (
                        <MenuItem key={city.id} value={city.id}>
                          {city.value}
                        </MenuItem>
                      ))}
                      {!cityList.find((c) => c.id === "0") && (
                        <MenuItem value="0">Others</MenuItem>
                      )}
                    </Select>
                    {field.value === "0" && (
                      <Controller
                        name="other_city"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: otherField }) => (
                          <TextField
                            {...otherField}
                            label="Others"
                            placeholder="Enter City Name*"
                            fullWidth
                            sx={{ mt: 2 }}
                          />
                        )}
                      />
                    )}
                  </>
                )}
              />
            </Box>
          </Box>
          <Box sx={{
            display: 'inline-flex',
            width: '100%',
            alignItems: 'center',
            margin: '10px'
          }}>
            <Box sx={{ width: '20%' }}>{'District:'}</Box>
            <Box sx={{ width: '50%' }}>
              <Controller
                name="district_id"
                control={control}
                rules={{ required: true }}
                render={({ field }) => (
                  <>
                    <Select
                      {...field}
                      label="District"
                      value={field.value || ""}
                      onChange={(e) => {
                        field.onChange(e.target.value); 
                        handleDistrictChange(e); 
                      }}
                      sx={{ width: '100%', overflow: 'visible', mb: 2 }}
                    >
                      {districtList.map((district) => (
                        <MenuItem key={district.id} value={district.id}>
                          {district.value}
                        </MenuItem>
                      ))}
                      {!districtList.find((d) => d.id === "0") && (
                        <MenuItem value="0">Others</MenuItem>
                      )}
                    </Select>
                    {field.value === "0" && (
                      <Controller
                        name="other_district"
                        control={control}
                        rules={{ required: true }}
                        render={({ field: otherField }) => (
                          <TextField
                            {...otherField}
                            label="Others"
                            placeholder="Enter District Name*"
                            fullWidth
                            sx={{ mt: 2 }}
                          />
                        )}
                      />
                    )}
                  </>
                )}
              />
            </Box>
          </Box>
          {countryCode === 'SA' && (
            <Controller
              name="premisesCode"
              control={control}
              rules={{
                required: 'National Address Short Code is required', validate: value =>
                  validateShortAddressCode(value) || 'Short Code must be 4 letters followed by 4 digits (e.g. RCTB4359)'
              }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label="National Address Short Code*"
                  fullWidth
                  inputProps={{ maxLength: 8 }} 
                  value={field.value ?? ''}
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          )}

          <Controller
            name='street'
            control={control}
            rules={{ required: true }}
            render={({ field }) => <TextField {...field} label={'Street Address*'} fullWidth />}
          />
          {props.isB2B && (
            <Controller
              name='building_no'
              control={control}
              rules={{ required: true }}
              render={({ field, fieldState: { error } }) => (
                <TextField
                  {...field}
                  label='Building No.*'
                  fullWidth
                  error={!!error}
                  helperText={error?.message}
                />
              )}
            />
          )}
          <Controller
            name='postcode'
            control={control}
            //rules={{ required: true}}
            render={({ field }) => <TextField {...field} label='Zip/Postal Code' fullWidth />}
          />
          {
            props.isOrderAddress &&
            <Controller
              name='phone_ext'
              control={control}
              //rules={{ required: true}}
              render={({ field }) => <TextField {...field} label='Country Phone Ext*' fullWidth InputProps={{ readOnly: true }}
                value={countryPhoneExt} />}
            />
          }
          <Controller
            name="telephone"
            control={control}
            rules={{
              required: "Phone number is required",
              validate: (value) => validatePhoneNumber(value),
            }}
            defaultValue={props.address?.telephone || ""}
            render={({ field, fieldState: { error } }) => (
              <TextField
                {...field}
                value={field.value || ""} // Ensure it resets when value is cleared
                placeholder={phonePH || "Enter phone number"}
                fullWidth
                error={!!error}
                helperText={error?.message || ""}
                onChange={(e) => handlePhoneInput(e, field.onChange)}
              />
            )}
          />
          <Typography variant='subtitle1' sx={{ fontsize: '.5rem', fontWeight: 400 }}>
            Remarks*
          </Typography>
          <Controller
            name="remarksString"
            control={control}
            rules={{
              required: 'Remarks are required',
              minLength: { value: 5, message: 'Min 5 characters' },
              maxLength: { value: 255, message: 'Max 255 characters' }
            }}
            render={({ field, fieldState: { error } }) => (
              <TextareaAutosize
                {...field}
                minRows={3}
                placeholder="Please add notes here (5 to 255 characters)"
                style={{
                  width: '100%',
                  padding: '10px',
                  fontSize: '1rem',
                  borderColor: error ? 'red' : '#c4c4c4',
                  borderWidth: '1px',
                  borderRadius: '4px'
                }}
              />
            )}
          />
          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
            <Button 
              onClick={() => cancelForm()}
              sx={{ textTransform: 'capitalize', padding: '7.5px 20px', color: '#2b3f7a', marginRight: '10px', border: '2px solid #2b3f7a', borderRadius:0 , marginTop: '10px'}}
            >
              Cancel
            </Button>
            <Button 
              onClick={() => submitForm()}
              sx={{ ...globalStyles.reusableButton, marginTop: '10px' }}
            >
              Save
            </Button>
          </Box>
          <Snackbar open={openAlert} autoHideDuration={3000} onClose={closeAlert} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
            <Alert onClose={closeAlert} severity="warning" sx={{ width: '400px', marginTop: '100px' }}>
              {alertText}
            </Alert>
          </Snackbar>
        </form>
      </Box>
    </Box>
  )
}

export default AddressForm
